import { render, staticRenderFns } from "./Editmimistator.vue?vue&type=template&id=1207f284&scoped=true"
import script from "./Editmimistator.vue?vue&type=script&lang=js"
export * from "./Editmimistator.vue?vue&type=script&lang=js"
import style0 from "./Editmimistator.vue?vue&type=style&index=0&id=1207f284&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1207f284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1207f284')) {
      api.createRecord('1207f284', component.options)
    } else {
      api.reload('1207f284', component.options)
    }
    module.hot.accept("./Editmimistator.vue?vue&type=template&id=1207f284&scoped=true", function () {
      api.rerender('1207f284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/Editmimistator.vue"
export default component.exports